/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.style.constants

// Html elements
const val HTML = "html"
const val BODY = "body"
const val H1 = "h1"
const val H2 = "h2"
const val H3 = "h3"
const val P = "p"
const val TEXTAREA = "textarea"
const val INPUT = "input"
const val LABEL = "label"
const val BUTTON = "button"
const val OL = "ol"
const val LI = "li"
const val B = "b"
const val A = "a"

const val HTML_ATTR_DISABLED = "disabled"
